import { render, staticRenderFns } from "./general-statistics-card.vue?vue&type=template&id=649416e6&"
import script from "./general-statistics-card.vue?vue&type=script&lang=js&"
export * from "./general-statistics-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports